/* eslint-disable */
import { ref, onBeforeMount, onUpdated } from 'vue'
import axios from 'axios'

export function getDepartmentAll(filter) {
	const departmentList = ref([])
	const ambilData = async () => {
		await axios
		.get('department-all', {
				params: filter
			})
			.then(res => {
				departmentList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, departmentList }
}

export function getDepartmentData(filter) {
	const departmentList = ref([])
	const ambilData = async () => {
		await axios
		.get('department', {
				params: filter
			})
			.then(res => {
				departmentList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, departmentList }
}

export function getMajorData(filter) {
	const majorList = ref([])
	const ambilData = async () => {
		await axios
		.get('getmajor', {
				params: filter
			})
			.then(res => {
				majorList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, majorList }
}

export function getDepartmentDataAll(filter) {
	const departmentList = ref([])
	const ambilData = async () => {
		await axios
		.get('departmentall', {
				params: filter
			})
			.then(res => {
				departmentList.value = res.data.data
		})
		.catch(error => {
			// console.log(JSON.stringify(error))
		})
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, departmentList }
}

export function getAcademicYearData ( filter ) {
	const academicYearList = ref([])
	const ambilData = async () => {
		await axios
		.get('academicyear', {
				params: filter
			})
			.then(res => {
				academicYearList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, academicYearList }
}

export function getSchoolYearData ( filter ) {
	const schoolYearList = ref([])
	const ambilData = async () => {
		await axios
		.get('schoolyear', {
				params: filter
			})
			.then(res => {
				schoolYearList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, schoolYearList }
}

export function getSchoolData ( filter ) {
	const schoolList = ref([])
	const ambilData = async () => {
		await axios
		.get('school', {
				params: filter
			})
			.then(res => {
				schoolList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, schoolList }
}

export function getTransactionApproval ( filter ) {
	const approvalList = ref([])
	const ambilData = async () => {
		await axios
		.get('transaction', {
				params: filter
			})
			.then(res => {
				approvalList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, approvalList }
}

export function getTransactionGroup ( filter ) {
	const groupList = ref([])
	const ambilData = async () => {
		await axios
		.get('transaction-group', {
				params: filter
			})
			.then(res => {
				groupList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, groupList }
}

export function getGroup ( filter ) {
	const groupList = ref([])
	const ambilData = async () => {
		// await axios
		// .get('role-group', {
		// 		params: filter
		// 	})
		// 	.then(res => {
		// 		groupList.value = res.data.data
		// })
		// .catch(error => {
		// 	console.log(JSON.stringify(error))
		// })
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, groupList }
}

export function getModulesCode ( filter ) {
	const modulesCodeList = ref([])
	const ambilData = async () => {
		await axios
		.get('modules-role-code', {
				params: filter
			})
			.then(res => {
				modulesCodeList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, modulesCodeList }
}

export function getRole ( filter ) {
	const roleList = ref([])
	const ambilData = async () => {
		await axios
		.get('role', {
				params: filter
			})
			.then(res => {
				roleList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, roleList }
}

export function getLevelData ( filter ) {
	const levelList = ref([])
	const ambilData = async () => {
		await axios
		.get('level', {
			params: filter
		})
			.then(res => {
				levelList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, levelList }
}

export function getBatchData ( filter ) {
	const batchList = ref([])
	const ambilData = async () => {
		await axios
		.get('batch', {
			params: filter
		})
			.then(res => {
				batchList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, batchList }
}

export function getEthnicData ( filter ) {
	const ethnicList = ref([])
	const ambilData = async () => {
		await axios
		.get('ethnic', {
			params: filter
		})
			.then(res => {
				ethnicList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, ethnicList }
}

export function getReligionData ( filter ) {
	const religionList = ref([])
	const ambilData = async () => {
		await axios
		.get('religion', {
			params: filter
		})
			.then(res => {
				religionList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, religionList }
}

export function getNewbatchData ( filter ) {
	const newbatchList = ref([])
	const ambilData = async () => {
		await axios
		.get('newbatch', {
			params: filter
		})
			.then(res => {
				newbatchList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, newbatchList }
}

export function getStudentstatusData ( filter ) {
	const studentstatusList = ref([])
	const ambilData = async () => {
		await axios
		.get('studentstatus', {
			params: filter
		})
			.then(res => {
				studentstatusList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, studentstatusList }
}

export function getUserData ( filter ) {
	const userList = ref([])
	const ambilData = async () => {
		await axios
		.get('users', {
			params: filter
		})
			.then(res => {
				userList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, userList }
}

export function getCategoryList ( filter ) {
	const categoryList = ref([])
	const ambilData = async () => {
		await axios
		.get('comboard-category', {
			params: filter
		})
			.then(res => {
				categoryList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, categoryList }
}


export function getStudent ( filter ) {
	const studentList = ref([])
	const ambilData = async () => {
		await axios
		.get('studentcondition', {
			params: filter
		})
			.then(res => {
				studentconditionList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, studentList }
}

export function getStudentconditionData ( filter ) {
	const studentconditionList = ref([])
	const ambilData = async () => {
		await axios
		.get('studentcondition', {
			params: filter
		})
			.then(res => {
				studentconditionList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, studentconditionList }
}

export function getFormerschoolData ( filter ) {
	const formerschoolList = ref([])
	const ambilData = async () => {
		await axios
		.get('formerschool', {
			params: filter
		})
			.then(res => {
				formerschoolList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, formerschoolList }
}

export function getEducationlevelData ( filter ) {
	const educationlevelList = ref([])
	const ambilData = async () => {
		await axios
		.get('educationlevel', {
			params: filter
		})
			.then(res => {
				educationlevelList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, educationlevelList }
}

export function getProfessionData ( filter ) {
	const professionList = ref([])
	const ambilData = async () => {
		await axios
		.get('profession', {
			params: filter
		})
			.then(res => {
				professionList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, professionList }
}

export function getCandidatesgroupData ( filter ) {
	const candidatesgroupList = ref([])
	const ambilData = async () => {
		await axios
		.get('candidatesgroup', {
			params: filter
		})
			.then(res => {
				candidatesgroupList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, candidatesgroupList }
}

export function getAcademicBatchData ( filter ) {
	const academicBatchList = ref([])
	const ambilData = async () => {
		await axios
		.get('academicbatch', {
			params: filter
		})
			.then(res => {
				academicBatchList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, academicBatchList }
}

export function getClassAll ( filter ) {
	const classList = ref([])
	const ambilData = async () => {
		await axios
		.get('class-all', {
			params: filter
		})
			.then(res => {
				classList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, classList }
}

export function getClassData ( filter ) {
	const classList = ref([])
	const ambilData = async () => {
		await axios
		.get('class', {
			params: filter
		})
			.then(res => {
				classList.value = res.data.select
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, classList }
}

export function getSiswaData ( filter ) {
	const siswaList = ref([])
	const ambilData = async () => {
		await axios
		.get('siswa', {
			params: filter
		})
			.then(res => {
				siswaList.value = res.data.select
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, siswaList }
}

export function getCandidatestestData ( filter ) {
	const candidatestestList = ref([])
	const ambilData = async () => {
		await axios
		.get('candidatestest', {
			params: filter
		})
			.then(res => {
				candidatestestList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, candidatestestList }
}

export function getSubjectData ( filter ) {
	const subjectList = ref([])
	const ambilData = async () => {
		await axios
		.get('subject', {
			params: filter
		})
			.then(res => {
				subjectList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, subjectList }
}

export function getTeacherroleData ( filter ) {
	const teacherroleList = ref([])
	const ambilData = async () => {
		await axios
		.get('teacherrole', {
			params: filter
		})
			.then(res => {
				teacherroleList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, teacherroleList }
}

export function getEmployeeData ( filter ) {
	const employeeList = ref([])
	const ambilData = async () => {
		await axios
		.get('employee', {
			params: filter
		})
			.then(res => {
				employeeList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, employeeList }
}

export function getExtracuricularData ( filter ) {
	const extracuricularList = ref([])
	const ambilData = async () => {
		await axios
		.get('extracuricular', {
			params: filter
		})
			.then(res => {
				extracuricularList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, extracuricularList }
}

export function getGradingAspectsData ( filter ) {
	const gradingaspectsList = ref([])
	const ambilData = async () => {
		await axios
		.get('gradingaspects', {
			params: filter
		})
			.then(res => {
				gradingaspectsList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, gradingaspectsList }
}

export function getSubjectGroupData ( filter ) {
	const subjectgroupList = ref([])
	const ambilData = async () => {
		await axios
		.get('subjectgroup', {
			params: filter
		})
			.then(res => {
				subjectgroupList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, subjectgroupList }
}

export function getVaccinesData ( filter ) {
	const vaccinesList = ref([])
	const ambilData = async () => {
		await axios
		.get('vaccines', {
			params: filter
		})
			.then(res => {
				vaccinesList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, vaccinesList }
}

export function getSemesterData ( filter ) {
	const semesterList = ref([])
	const ambilData = async () => {
		await axios
		.get('semester', {
			params: filter
		})
			.then(res => {
				semesterList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, semesterList }
}

export function getSyllabusDetailData ( filter ) {
	const syllabusdetailList = ref([])
	const ambilData = async () => {
		await axios
		.get('syllabusdetail', {
			params: filter
		})
			.then(res => {
				syllabusdetailList.value = res.data.select
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, syllabusdetailList }
}

export function getLearningMethod ( filter ) {
	const learningmethodList = ref([])
	const ambilData = async () => {
		await axios
		.get('learningmethod', {
			params: filter
		})
			.then(res => {
				learningmethodList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, learningmethodList }
}

export function getAssignmentTypeData ( filter ) {
	const assignmenttypeList = ref([])
	const ambilData = async () => {
		await axios
		.get('assignmenttype', {
			params: filter
		})
			.then(res => {
				assignmenttypeList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, assignmenttypeList }
}

export function getLessonplanSession ( filter ) {
	const lessonplansessionList = ref([])
	const ambilData = async () => {
		await axios
		.get('lessonplansession', {
			params: filter
		})
			.then(res => {
				lessonplansessionList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, lessonplansessionList }
}

export function getLessonplanData ( filter ) {
	const lessonplanList = ref([])
	const ambilData = async () => {
		await axios
		.get('lessonplan', {
			params: filter
		})
			.then(res => {
				lessonplanList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, lessonplanList }
}

export function getTeacherData ( filter ) {
	const teacherList = ref([])
	const ambilData = async () => {
		await axios
		.get('teacher', {
			params: filter
		})
			.then(res => {
				teacherList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, teacherList }
}

export function getStudytimeData ( filter ) {
	const studytimeList = ref([])
	const ambilData = async () => {
		await axios
		.get('studytime', {
			params: filter
		})
			.then(res => {
				studytimeList.value = res.data.data
	console.log('tes study', studytimeList.value)
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, studytimeList }
}

export function getSchooltimeData ( filter ) {
	const schooltimeList = ref([])
	const ambilData = async () => {
		await axios
		.get('studytime', {
			params: filter
		})
			.then(res => {
				schooltimeList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, schooltimeList }
}

export function getStudentData ( filter ) {
	const studentList = ref([])
	const ambilData = async () => {
		await axios
		.get('students',{
			params: filter})
			.then(res => {
				studentList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, studentList }
}

export function getCoacategoryData ( filter ) {
	const coacategoryList = ref([])
	const ambilData = async () => {
		await axios
		.get('coacategory', {
			params: filter
		})
			.then(res => {
				coacategoryList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, coacategoryList }
}

export function getCoahartaData ( filter ) {
	const coahartaList = ref([])
	const ambilData = async () => {
		await axios
		.get('coaharta', {
			params: filter
		})
			.then(res => {
				coahartaList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, coahartaList }
}

export function getIncomecategoryData ( filter ) {
	const incomecategoryList = ref([])
	const ambilData = async () => {
		await axios
		.get('incomecategory', {
			params: filter
		})
			.then(res => {
				incomecategoryList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, incomecategoryList }
}

export function getTypesofincomeData ( filter ) {
	const typesofincomeList = ref([])
	const ambilData = async () => {
		await axios
		.get('income', {
			params: filter
		})
			.then(res => {
				typesofincomeList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, typesofincomeList }
}

export function getFinancialyearData ( filter ) {
	const financialyearList = ref([])
	const ambilData = async () => {
		await axios
		.get('financialyear', {
			params: filter
		})
			.then(res => {
				financialyearList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, financialyearList }
}

export function getJournaltypeData ( filter ) {
	const journaltypeList = ref([])
	const ambilData = async () => {
		await axios
		.get('journaltype', {
			params: filter
		})
			.then(res => {
				journaltypeList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, journaltypeList }
}
export function getJournaltypePaymentData ( filter ) {
	const journaltypeList = ref([])
	const ambilData = async () => {
		await axios
		.get('journaltypepayment', {
			params: filter
		})
			.then(res => {
				journaltypeList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, journaltypeList }
}

export function getScheduleData ( filter ) {
	const scheduleList = ref([])
	const ambilData = async () => {
		await axios
		.get('schedule', {
			params: filter
		})
			.then(res => {
				scheduleList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, scheduleList }
}

export function getSubjectTeacher ( filter ) {
	const subjectteacherList = ref([])
	const ambilData = () => {
		axios
		.get('getsubject', {
			params: filter
		})
			.then(res => {
				subjectteacherList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, subjectteacherList }
}

export function getSubjectStreamingTeacher ( filter ) {
	const subjectteacherList = ref([])
	const ambilData = () => {
		axios
		.get('getsubjectstreaming', {
			params: filter
		})
			.then(res => {
				subjectteacherList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, subjectteacherList }
}

export function getClassTeacher ( filter ) {
	const classteacherList = ref([])
	const ambilData = () => {
		axios
		.get('getclass', {
			params: filter
		})
			.then(res => {
				console.log(res)
				classteacherList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, classteacherList }
}

export function getDepartmentTeacherData ( filter ) {
	const departmentteacherList = ref([])
	const ambilData = async () => {
		await axios
		.get('getdepartment', {
			params: filter
		})
			.then(res => {
				departmentteacherList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, departmentteacherList }
}


export function getStudyTime ( filter ) {
	const studytimeList = ref([])
	const ambilData = async () => {
		await axios
		.get('getstudytime', {
			params: filter
		})
			.then(res => {
				studytimeList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		console.log('getStudyTime', filter)
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, studytimeList }
}

export function getWorkunit ( filter ) {
	const workunitList = ref([])
	const ambilData = async () => {
		await axios
		.get('workunit', {
			params: filter
		})
			.then(res => {
				workunitList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, workunitList }
}

export function getShift ( filter ) {
	const shiftList = ref([])
	const ambilData = async () => {
		await axios
		.get('shift', {
			params: filter
		})
			.then(res => {
				shiftList.value = res.data.data
				const concat = {id: 'all', name:'ALL'}
				shiftList.value = [concat].concat(shiftList.value)
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, shiftList }
}

export function getPositionData ( filter ) {
	const positionList = ref([])
	const ambilData = async () => {
		await axios
		.get('position', {
			params: filter
		})
			.then(res => {
				positionList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, positionList }
}

export function getLeaveData ( filter ) {
	const leaveList = ref([])
	const ambilData = async () => {
		await axios
		.get('leave', {
			params: filter
		})
			.then(res => {
				leaveList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, leaveList }
}

export function getRoleData ( filter ) {
	const roleList = ref([])
	const ambilData = async () => {
		await axios
		.get('role', {
			params: filter
		})
			.then(res => {
				roleList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, roleList }
}

export function getRoleGroupData ( filter ) {
	const roleGroupList = ref([])
	const ambilData = async () => {
		// await axios
		// .get('role-group', {
		// 	params: filter
		// })
		// 	.then(res => {
		// 		roleGroupList.value = res.data.data
		// })
		// .catch(error => {
		// 	console.log(JSON.stringify(error))
		// })
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, roleGroupList }
}

export function getVaData ( filter ) {
	const vaList = ref([])
	const ambilData = async () => {
		await axios
		.get('vacodelist', {
			params: filter
		})
			.then(res => {
				vaList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, vaList }
}

export function getDepartmentAllData(filter) {
	const departmentList = ref([])
	const ambilData = async () => {
		await axios
		.get('department', filter)
			.then(res => {
				departmentList.value = res.data.data
				const newData = {id: 'ALL', name: 'ALL'}
			departmentList.value = [newData].concat(departmentList.value)
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, departmentList }
}

export function getTRgroupListData ( filter ) {
	const trgroupList = ref([])
	const ambilData = async () => {
		await axios
		.get('transaction-group', {
			params: filter
		})
			.then(res => {
				trgroupList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, trgroupList }
}

export function getSubjectDataParent ( filter ) {
	const subjectList = ref([])
	const ambilData = async () => {
		await axios
		.get('subject-parent', {
			params: filter
		})
			.then(res => {
				subjectList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, subjectList }
}

export function getAcademicYearDataParent ( filter ) {
	const academicYearList = ref([])
	const ambilData = async () => {
		await axios
		.get('academicyear-parent', {
				params: filter
			})
			.then(res => {
				academicYearList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, academicYearList }
}

export function getDepartmentDataParent(filter) {
	const departmentList = ref([])
	const ambilData = async () => {
		await axios
		.get('department-parent', {
				params: filter
			})
			.then(res => {
				departmentList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}
		onBeforeMount(() => {
			ambilData()
		})

		onUpdated(() => {
			ambilData()
		})

	return { ambilData, departmentList }
}
export function getIncomecategoryDataParent ( filter ) {
	const incomecategoryList = ref([])
	const ambilData = async () => {
		await axios
		.get('incomecategory-parent', {
			params: filter
		})
			.then(res => {
				incomecategoryList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, incomecategoryList }
}
export function getFinancialyearDataParent ( filter ) {
	const financialyearList = ref([])
	const ambilData = async () => {
		await axios
		.get('financialyear-parent', {
			params: filter
		})
			.then(res => {
				financialyearList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, financialyearList }
}
export function getClassDataParent ( filter ) {
	const classList = ref([])
	const ambilData = async () => {
		await axios
		.get('class-parent', {
			params: filter
		})
			.then(res => {
				classList.value = res.data.select
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, classList }
}
export function getLevelDataParent ( filter ) {
	const levelList = ref([])
	const ambilData = async () => {
		await axios
		.get('level-parent', {
			params: filter
		})
			.then(res => {
				levelList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, levelList }
}
export function getNewbatchDataParent ( filter ) {
	const newbatchList = ref([])
	const ambilData = async () => {
		await axios
		.get('newbatch-parent', {
			params: filter
		})
			.then(res => {
				newbatchList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, newbatchList }
}
export function getCandidatesgroupDataParent ( filter ) {
	const candidatesgroupList = ref([])
	const ambilData = async () => {
		await axios
		.get('candidatesgroup-parent', {
			params: filter
		})
			.then(res => {
				candidatesgroupList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, candidatesgroupList }
}
export function getJournaltypeDataParent ( filter ) {
	const journaltypeList = ref([])
	const ambilData = async () => {
		await axios
		.get('journaltype-parent', {
			params: filter
		})
			.then(res => {
				journaltypeList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, journaltypeList }
}

export function getSemesterDataParent ( filter ) {
	const semesterList = ref([])
	const ambilData = async () => {
		await axios
		.get('semester-parent', {
			params: filter
		})
			.then(res => {
				semesterList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, semesterList }
}

export function getStudytimeDataParent ( filter ) {
	const studytimeList = ref([])
	const ambilData = async () => {
		await axios
		.get('studytime-parent', {
			params: filter
		})
		.then(res => {
			studytimeList.value = res.data.data
			console.log('tes study', studytimeList.value)
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, studytimeList }
}

export function getScheduleDataParent ( filter ) {
	const scheduleList = ref([])
	const ambilData = async () => {
		await axios
		.get('schedule-parent', {
			params: filter
		})
			.then(res => {
				scheduleList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, scheduleList }
}

export function getPeriod ( filter ) {
	const periodList = ref([])
	const ambilData = async () => {
		await axios
		.get('getperiod', {
			params: filter
		})
			.then(res => {
				periodList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, periodList }
}
export function getDepart ( filter ) {
	const departList = ref([])
	const ambilData = async () => {
		await axios
		.get('getdepart', {
			params: filter
		})
			.then(res => {
				departList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, departList }
}
export function getPosition ( filter ) {
	const positionList = ref([])
	const ambilData = async () => {
		await axios
		.get('getposition', {
			params: filter
		})
			.then(res => {
				positionList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, positionList }
}
export function getInstrument ( filter ) {
	const instrumentList = ref([])
	const ambilData = async () => {
		await axios
		.get('getinstrument', {
			params: filter
		})
			.then(res => {
				instrumentList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, instrumentList }
}
export function getOptions ( filter ) {
	const optionsList = ref([])
	const ambilData = async () => {
		await axios
		.get('getoptions', {
			params: filter
		})
			.then(res => {
				optionsList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, optionsList }
}
export function getIndicatorParent ( filter ) {
	const indicatorparentList = ref([])
	const ambilData = async () => {
		await axios
		.get('getindicatorparent', {
			params: filter
		})
			.then(res => {
				indicatorparentList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, indicatorparentList }
}
export function getIndicator ( filter ) {
	const indicatorList = ref([])
	const ambilData = async () => {
		await axios
		.get('getindicator', {
			params: filter
		})
			.then(res => {
				indicatorList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, indicatorList }
}
export function getState ( filter ) {
	const stateList = ref([])
	const ambilData = async () => {
		await axios
		.get('getstate', {
			params: filter
		})
			.then(res => {
				stateList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, stateList }
}
export function getInstrumentSource ( filter ) {
	const instrumentsourceList = ref([])
	const ambilData = async () => {
		await axios
		.get('getinstrumentsource', {
			params: filter
		})
			.then(res => {
				instrumentsourceList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, instrumentsourceList }
}
export function getScoringOption ( filter ) {
	const scoringoptionList = ref([])
	const ambilData = async () => {
		await axios
		.get('getscoringoption', {
			params: filter
		})
			.then(res => {
				scoringoptionList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, scoringoptionList }
}
export function getTargetOption ( filter ) {
	const targetoptionList = ref([])
	const ambilData = async () => {
		await axios
		.get('gettargetoption', {
			params: filter
		})
			.then(res => {
				targetoptionList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, targetoptionList }
}
export function getQualityScoring ( filter ) {
	const qualityscoringList = ref([])
	const ambilData = async () => {
		await axios
		.get('getqualityscoring', {
			params: filter
		})
			.then(res => {
				qualityscoringList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, qualityscoringList }
}
export function getCombineScoreMethod ( filter ) {
	const combinescoremethodList = ref([])
	const ambilData = async () => {
		await axios
		.get('getcombinescoremethod', {
			params: filter
		})
			.then(res => {
				combinescoremethodList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, combinescoremethodList }
}
export function getInstrumentOptions ( filter ) {
	const instrumentoptionsList = ref([])
	const ambilData = async () => {
		await axios
		.get('getinstrumentoptions', {
			params: filter
		})
			.then(res => {
				instrumentoptionsList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, instrumentoptionsList }
}
export function getPersenData ( filter ) {
	const persenList = ref([])
	const ambilData = () => {
		axios
		.get('get-persen', {
			params: filter
		})
			.then(res => {
				console.log(res)
				persenList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, persenList }
}
export function GetDocumentCategory ( filter ) {
	const domainList = ref([])
	const ambilData = () => {
		axios
		.get('parentList', {
			params: filter
		})
			.then(res => {
				console.log(res)
				domainList.value = res.data.data
		})
		.catch(error => {
			console.log(JSON.stringify(error))
		})
	}

	onBeforeMount(() => {
		ambilData()
	})

	onUpdated(() => {
		ambilData()
	})

	return { ambilData, domainList }
}
